<template>
    <gj-modal
        v-bind="$attrs"
        v-on="$listeners"
        size="680_auto"
        :visible.sync="modalVisible"
        :confirmLoading="confirmLoading"
        notFooterPadding
        @open="resetData"
        @cancel="cancel"
        @close="cancel"
        @confirm="confirm">
        <span slot="header">
            <template v-if="current && current.id">编辑视图</template>
            <template v-else>添加视图</template>
        </span>
        <div class="view-add" slot="content">
            <el-form :model="formData" :rules="formRules" ref="viewForm">
                <el-row v-for="item in formRows" :key="item.prop">
                    <el-form-item
                        :label="item.label"
                        :label-width="item.labelWidth || '120px'"
                        :prop="item.prop"
                    >
                        <slot :name="item.prop" :form-data="formData" :config="config" :form-row="item"></slot>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
    </gj-modal>
</template>

<script>
    import { modalMixIn } from "@/minxins"
    import {
        postAddView,
        putEditView
    } from "@/api/common"
    import {
        type,
        generateUUID
    } from "@/utils/common";
    import TtlLocalStorage from "@/utils/storage";
    const storage = new TtlLocalStorage({
        namespace: 'VIEW'
    })
    export default {
        name: "view-add",
        mixins: [ modalMixIn ],
        props: {
            // 模块名，属上级组件透传
            moduleName: {
                type: String,
                required: true
            },
            // 视图详情
            current: {
                type: Object,
                default() {
                    return {}
                }
            },
            // 表单校验项，属上级组件透传
            formRules: {
                type: Object,
                default() {
                    return {}
                }
            },
            // 表单绑定数据，属上级组件透传
            formData: {
                type: Object,
                default () {
                    return {}
                }
            },
            // form-item组， 属上级组件透传
            formRows: {
                type: Array,
                default() {
                    return []
                }
            },
            // 配置表单选项，属上级组件透传
            config: {
                type: Array,
                default() {
                    return []
                }
            },
            // 构造参数的方法 同时需要return出构造完成的参数, 返回类型为 {Promise<void>}
            fnGenerateParams: {
                type: Function
            },
            saveMode: {
                type: String,
                default: 'remote'
            }
        },
        data () {
            return {

            }
        },
        methods: {
            /**
             * 确认新增视图
             * @returns {Promise<void>}
             */
            async confirm () {
                let params = this.formData
                if (this.fnGenerateParams && type(this.fnGenerateParams) === 'function') {
                    params = await this.fnGenerateParams(params)
                }

                const id = this.current?.id ? this.current.id : this.saveMode === 'local' ? generateUUID() : ''

                let fetchParams = {
                    params: JSON.stringify(params),
                    module: this.moduleName,
                    name: params.name,
                    id,
                    selected: true
                }

                this.$refs.viewForm.validate(async valid => {
                    if (valid) {
                        const saveMode = this.saveMode
                        if (saveMode === 'local') {
                            let viewList = await storage.get(this.moduleName)
                            if (!viewList) viewList = []
                            const index = viewList.findIndex(v => v.id === fetchParams.id)

                            if (index < 0) {
                                viewList.push(fetchParams)
                            }

                            for (let v of viewList) {
                                if (v.id === fetchParams.id) {
                                    v = Object.assign(v, fetchParams)
                                } else {
                                    v.selected = false
                                }
                            }

                            await storage.set(this.moduleName, viewList)
                        } else {
                            fetchParams.id ? await putEditView(fetchParams) : await postAddView(fetchParams)
                        }

                        this.$gjMessage.success('更新成功')
                        this.$emit('custom-confirm')
                    }
                })
            },
            /**
             * 打开弹窗重置数据
             */
            async resetData () {
                this.$parent.initFields(this.current ? 'edit' : 'add')
                this.$nextTick(() => {
                    this.$refs.viewForm.clearValidate()
                })
            }
        },
    }
</script>

<style scoped>

</style>
